
import { Navigation } from "@/components/landingPage/Navigation";
import { Hero } from "@/components/landingPage/Hero";
import { ProblemSection } from "@/components/landingPage/ProblemSection";
import { HowItWorks } from "@/components/landingPage/HowItWorks";
import { Benefits } from "@/components/landingPage/Benefits";
import { TargetAudience } from "@/components/landingPage/TargetAudience";
import { Pricing } from "@/components/landingPage/Pricing";
import { FAQ } from "@/components/landingPage/FAQ";
import { JoinWaitlist } from "@/components/landingPage/JoinWaitlist";

const Index = () => {
  return (
    <div className="min-h-screen bg-spa-beige">
      <Navigation />
      <Hero />
      <ProblemSection />
      <HowItWorks />
      <Benefits />
      <TargetAudience />
      <Pricing />
      <FAQ />
      <JoinWaitlist />
    </div>
  );
};

export default Index;
